import React, {Component} from 'react';
import KPI from './Kpi';
import jwt_decode from "jwt-decode";
import ColumnChart from '../amcharts/ColumnChart';
import LineChart from '../amcharts/LineChart';
import PieChart from '../amcharts/PieChart';
import StackedColumnChart from '../amcharts/StackedColumnChart';
import BarAndLineChart from '../amcharts/BarAndLineChart';
import BarChart from '../amcharts/BarChart';
import PieofPieChart from '../amcharts/PieOfPieChart';
import axios from "axios";
import config from "react-global-configuration";
import "react-datepicker/dist/react-datepicker.css";
import * as moment from "moment";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import {css} from "@emotion/core";
import { List } from 'react-virtualized';
import {connect}  from  "react-redux";
import {BeatLoader} from "react-spinners";
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
const queryString = require('query-string');
var yesterday = new Date(Date.now() - 24*60*60*1000);
var yestSend = moment(yesterday).format('YYYY-MM-DD');

var todayDate = new Date();
var minDate = new Date('2020-01-01');
var timestamp  = new Date().getTime();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(todayDate).format('MM/DD/YYYY');
var yest = moment(todayDate).format('MM/DD/YYYY');
var todShow = moment(todayDate).format('D MMM YYYY');
var yestShow = moment(todayDate).format('D MMM YYYY');
var todSend = moment(todayDate).format('YYYY-MM-DD');
var yestSend = moment(todayDate).format('YYYY-MM-DD');
var date_limit = moment(todayDate).format('MM/DD/YYYY');
var start_date_limit = moment(minDate).format('MM/DD/YYYY');

function numDifferentiation(val) {
    if(val >= 10000000) val = (val/10000000).toFixed(2) + ' Cr';
    else if(val >= 100000) val = (val/100000).toFixed(2) + ' Lakh';
    else if(val >= 1000) val = (val/1000).toFixed(2) + ' K';
    return val;
}
Array.prototype.move = function(from,to){
    this.splice(to,0,this.splice(from,1)[0]);
    return this;
};

class DashboardDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            kpiData: [],
            chartHeight: "250px",
            dashbordDetail: [],
            chart_data: [],
            divWidth: '',
            startDate: yestSend,
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            dateTo: tod,
            dateLimit: date_limit,
            dateFromLimit: start_date_limit,
            dateToShow: todShow,
            todSend: todSend,
            yestSend: yestSend,
            datefrom: yest,
            datefromShow: yestShow,
            merchantList: [],
            chainList: [],
            merchantID: '',
            chainID: '',
            storeID: '',
            merchantValue: null,
            chainValue: null,
            storeList: [],
            acqBankList: [],
            acqBankValue: null,
            acqBankIds: '',
            dashId: '',
            last_updated: '',
            is_store_loading: true,
            is_chain_loading: true,
            is_merchant_loading: true,
            storeListOpen: false,
            storeHeaderTitle: "Select [Store]",
            object_code: [],
            storeObject: [],
            search_object_code:[]
        }
        this.closeStoreList = this.closeStoreList.bind(this);
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        }
    componentDidUpdate() {
        const { storeListOpen } = this.state;
        setTimeout(() => {
            if (storeListOpen) {
                window.addEventListener('click', this.closeStoreList);
            } else {
                window.removeEventListener('click', this.closeStoreList);
            }
        }, 0);
    }
    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);

        var parsed = queryString.parse(this.props.location.search);
        let dashId = parsed.dashId;
        this.setState({
            dashId:dashId
        })

        this.get_dashboard_type(dashId);
        this._getAllMerchants();
        this._get_acq_banks();
    }


    get_dashboard_type(dash){
        axios.get(config.get('API_URL')+'/reportdashboard/get-dashboard-type/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                dashboard_id: dash
            }
        }).then(response => {
            this.setState({
                last_updated:response.data.data_updated_at
            })
            this.filter_permission(response.data.dashboard_type, dash);
        });
    }

    filter_permission(dash_type, dashId){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        var stringCode = decoded.object_code
        var arrayCode = stringCode.split(",");

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
        });

        if(dash_type=='Merchant') {
            if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {
                this.getChain(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code);
                this.getStore(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code, false,'');
                this.setState({
                    merchant_list_box: true,
                    chain_list_box: true,
                    store_list_box: true,
                    acq_bank_list_box: false,
                    search_code: decoded.object_code,
                    search_type:'innoviti',
                    search_object_code: decoded.object_code,
                })
                this.get_dash_details(dashId, '','', this.state.yestSend, this.state.todSend,'')
            }
            else if(decoded.object_type=='Merchant') {
                this.getChain(arrayCode, 'merchant', decoded.object_type, arrayCode);
                this.getStore(arrayCode, 'merchant', decoded.object_type, arrayCode,false,'');
                var merchantData = [];
                arrayCode.map((value, index) => {
                    merchantData.push({"value": value, "label": ""})
                })

                this.changeMerchant('merchant', merchantData);
                setTimeout(function(){
                    this.get_dash_details(dashId, decoded.object_type,arrayCode, this.state.yestSend, this.state.todSend,'')
                }.bind(this), 200);

                this.setState({
                    merchant_list_box: false,
                    chain_list_box: true,
                    store_list_box: true,
                    acq_bank_list_box: false,
                    search_code: arrayCode,
                    search_type:'merchant',
                    search_object_code: arrayCode,
                })
            }
            else if(decoded.object_type=='Chain') {
                this.getStore(arrayCode, 'chain', decoded.object_type, arrayCode,false,'');
                var chainData = [];
                arrayCode.map((value, index) => {
                    chainData.push({"value": value, "label": ""})
                })
                this.changeChain('chain', chainData);
                setTimeout(function(){
                    this.get_dash_details(dashId, decoded.object_type,arrayCode, this.state.yestSend, this.state.todSend,'')
                }.bind(this), 200);
                this.setState({
                    merchant_list_box: false,
                    chain_list_box: false,
                    store_list_box: true,
                    acq_bank_list_box: false,
                    search_code: arrayCode,
                    search_type:'chain',
                    search_object_code: arrayCode,
                })
            }
            else if(decoded.object_type=='Store') {
                var storeData = [];
                arrayCode.map((value, index) => {
                    storeData.push({"value": value, "label": ""})
                })
                this.changeStore('store', storeData, true);
                setTimeout(function(){
                    this.get_dash_details(dashId, decoded.object_type,arrayCode, this.state.yestSend, this.state.todSend,'')
                }.bind(this), 200);
                this.setState({
                    merchant_list_box: false,
                    chain_list_box: false,
                    store_list_box: false,
                    acq_bank_list_box: false,
                    search_code: arrayCode,
                    search_type:'store'
                })
            }
            else{
                this.unauthorize_access();
            }
        } else if(dash_type=='Acquirer') {
            if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {
                this.setState({
                    merchant_list_box: false,
                    chain_list_box: false,
                    store_list_box: false,
                    acq_bank_list_box: true,
                })
                this.get_dash_details(dashId, '','', this.state.yestSend, this.state.todSend,'')
            }
            else if(decoded.object_type=='Acquirer Bank') {
                var storeData = [{"value":decoded.object_code, "label":""}]
                this.change_acq_banks(storeData);
                this.setState({
                    merchant_list_box: false,
                    chain_list_box: false,
                    store_list_box: false,
                    acq_bank_list_box: false,
                })
            }
            else{
                this.unauthorize_access();
            }
        }
    }


    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";

    }
    _get_acq_banks() {
        axios.get(config.get('API_URL')+'/reports/acq-banks/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            var that = this;
            if(response.data.data != null) {
                Object.keys(response.data.data).map(function (key, i) {
                    that.state.acqBankList.push({value: response.data.data[key], label: key})
                });
            }
        });
        this.setState({
            loading: false
        })
    }
    change_acq_banks(optionSelected) {
        //console.log(optionSelected);
        let value = '';
        let acqBankArray = [];
        if (optionSelected.length<1) {
            value = null;
            acqBankArray = '';
        } else {
            optionSelected.map((mids, i) => {
                var index = this.state.acqBankList.findIndex(obj => obj.value==mids.value);
                this.state.acqBankList.move(index,0).join(',');
                mids.value.map((mids1, i) => {
                    acqBankArray.push(mids1)
                });
            });
        }
        this.setState({
            acqBankIds: acqBankArray,
            acqBankValue: optionSelected,
        });

        //this.get_dash_details(this.state.dashId, '','', this.state.yestSend, this.state.todSend);
        // this._get_filtered_emi_scheme_report(this.state.merchantID, this.state.chainID, this.state.storeID, acqBankArray, this.state.cityIds,this.state.frequency,
        //     this.state.yestSend, this.state.todSend);
    }

    _getAllMerchants(){
        axios.get(config.get('API_URL')+'/reports/get-merchant/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var mList = []
                response.data.map((merchant, index) => {
                    mList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                });
                this.setState({
                    merchantList:mList,
                    is_merchant_loading: false
                })
            }
        });
    }

    changeMerchant(login_type, optionSelected){
        //console.log(this.state.merchantList);
        let value='';
        let midArray = [];
        if(optionSelected.length<1){
            value = null;
            midArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                if (login_type != 'merchant') {
                    var index = this.state.merchantList.findIndex(obj => obj.value == mids.value);
                    this.state.merchantList.move(index, 0).join(',');
                }
            });
        }
        this.setState({
            merchantID:midArray,
            chainID:'',
            merchantValue:optionSelected,
            chainValue:[],
            storeID:'',
            storeValue: [],
            search_code: midArray,
            search_type:'merchant',
            storeObject:[],
            search_object_code: this.state.object_code,
            isChange: true,
        });
        //this.get_dash_details(this.state.dashId, '','', this.state.yestSend, this.state.todSend);
        if(login_type==''){
            this.getChain(midArray, 'merchant', this.state.object_type, this.state.object_code);
            this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code,false,'');
        }

    }
    getChain(code, type, object_type, object_code){
        axios.post(config.get('API_URL')+'/reports/get-chain/',{
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID:''});
            response.data.map((chain,index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name})
            });
            this.setState({
                chainList:chalinList,
                is_chain_loading: false
            })
        });
    }
    changeChain(login_type, optionSelected) {
        let value='';
        let cidArray = [];
        if(optionSelected.length<1){
            value = null;
            cidArray = '';
        }
        else{
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)
                if (login_type != 'chain') {
                    var index = this.state.chainList.findIndex(obj => obj.value == cids.value);
                    this.state.chainList.move(index, 0).join(',');
                }
            });
        }

        this.setState({
            chainID: cidArray,
            chainValue:optionSelected,
            storeID:'',
            storeValue: [],
            search_code: cidArray,
            search_type:'chain',
            storeObject:[],
            search_object_code: this.state.merchantID,
            isChange: true,
        });

        //this.get_dash_details(this.state.dashId, '','', this.state.yestSend, this.state.todSend);
        if(login_type==''){
            this.getStore(cidArray, 'chain', this.state.object_type, this.state.merchantID,false,'');
        }

    }
    getStore(code, type, object_type, object_code,is_search, search_value) {
        let selected_val = [];
        if(is_search===true){
            selected_val = this.state.storeObject
        }
        this.setState({
            storeList:[],
            is_store_loading: true
        })
        axios.post(config.get('API_URL')+'/reports/get-batch-store-filter/', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code,
                is_search: is_search,
                search_value: search_value,
                selected_value: selected_val
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            let storeList = [];
            //this.setState({storeID:''});
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name})
            });
            let res = []
            if (Array.isArray(this.state.storeID) && this.state.storeID) {
                const uniq = new Set(storeList.map(e => JSON.stringify(e)));

                storeList = Array.from(uniq).map(e => JSON.parse(e));

            }
            this.setState({
                storeList:storeList,
                is_store_loading: false
            })
        });
    }
    changeStore(login_type, store_object, checked_item, e) {
        if (login_type === 'store') {
            let value='';
            let sidArray = [];
            if(store_object.length<1){
                value = null;
                sidArray = '';
            }
            else{
                store_object.map((sids, i) => {
                    sidArray.push(sids.value)
                });
            }
            //var is_enable = compareValues(sidArray, this.state.active_sids);
            this.setState({
                storeID: sidArray,
                storeValue:store_object,
                ciutidIds: '',
                ciutidValue: [],
                isChange: true
            });
        } else {
            let item_list = this.state.storeID;
            let item_list_object = this.state.storeObject;
            let checked_list = store_object.value;
            let checked_list_object = store_object;
            //console.log(checked_list);
            if(checked_item===false) {
                const newData = [store_object, ...this.state.storeList.filter(item => item !== store_object)];
                this.setState({
                    storeID: [...this.state.storeID,  store_object.value],
                    storeObject: [...this.state.storeObject, store_object],
                    isChange: true,
                    storeList: newData,
                    ciutidIds: '',
                    ciutidValue: [],
                });

            } else{
                let index = item_list.indexOf(checked_list);
                if (index > -1) {
                    item_list.splice(index, 1);
                    if(item_list.length<1) {
                        item_list='';
                    }
                    this.setState({
                        storeID: item_list,
                        isChange: true,
                        ciutidIds: '',
                        ciutidValue: [],
                    })
                }
                let index_object = item_list_object.indexOf(checked_list_object);
                if (index_object > -1) {
                    item_list_object.splice(index_object, 1);
                    if(item_list_object.length<1) {
                        item_list_object=[];
                    }
                    this.setState({
                        storeObject: item_list_object,
                        isChange: true
                    })
                }
            }
            if (e.target.type === 'checkbox') {
                e.stopPropagation();
            }

        }
        //this.get_dash_details(this.state.dashId, '','', this.state.yestSend, this.state.todSend);

    }
    storeToggleList() {
        this.setState({
            storeListOpen: !this.state.storeListOpen,
        });
    }
    storeFilterList(e){
        var value = e.target.value

        setTimeout(function() {
            this.getStore(this.state.search_code, this.state.search_type, this.state.object_type, this.state.search_object_code,true, value);
        }.bind(this), 200);
    }
    closeStoreList() {
        this.setState({
            storeListOpen: false,
        });
    }


    handleEvent(event, picker, e) {
        this.setState({
            todSend: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow: moment(picker.endDate).format('D MMM YYYY')
        });
        if(event.type=='apply'){
            this.setState({
                isChange: true
            })

            //this.get_dash_details(this.state.dashId, '','', this.state.yestSend, this.state.todSend);
            // this._get_filtered_emi_scheme_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds, this.state.frequency,
            //     this.state.yestSend, this.state.todSend)
        }
    }
    handleFromChange = date => { //alert(date);
        var parsed = queryString.parse(this.props.location.search);
        let dashId = parsed.dashId;
        var date_filter = moment(date).format('YYYY-MM-DD');
        this.setState({
            startDate: date_filter
        });
        this.get_dash_details(dashId, this.state.object_type, this.state.object_code, date_filter)
    };

    get_dash_details(dashId, party_type, party_code, startDate, endDate, e){

        axios.get(config.get('API_URL') + '/reportdashboard/getDashboardDetails/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                dashboard_id: dashId
            }
        }).then(response => {

            this.setState({
                chart_data: [],
                kpiData:[],
                isChange: false
            });
            var chartCount = 0;
            var kpiCount = 0;
            response.data.map((kdata, index) => {
                if (kdata.ui_component_type === 'kpi') {
                    this.getKPI(kdata.kpi_id, party_type, party_code, kpiCount, startDate, endDate);
                    this.setState({kpiData: [...this.state.kpiData, ""]})
                    kpiCount++;
                } else if (kdata.ui_component_type === 'chart') {
                    this.getChart(kdata.chart_id, party_type, party_code, chartCount, startDate, endDate);
                    this.setState({chart_data: [...this.state.chart_data, ""]})
                    chartCount++;
                }
            })
        });
    }

    getKPI(kpi_id, party_type, party_code, index, start_date, end_date) {

        // var mids = '';
        // var cids = '';
        // var sids = [25148];
        // var bids = '';
        // if(party_type=='Merchant') {
        //     mids = party_code;
        // } else if(party_type=='Chain') {
        //     cids = party_code;
        // } else if(party_type=='Store') {
        //     sids = party_code;
        // }
        // else if(party_type=='Acquirer Bank') {
        //     sids = party_code;
        // }
        //alert(this.state.merchantID)
        axios.post(config.get('API_URL') + '/reportdashboard/kpiDetails/', {

                kpi_id: kpi_id,
                mids: this.state.merchantID,
                cids: this.state.chainID,
                sids: this.state.storeID,
                bids: this.state.acqBankIds,
                start_date: start_date,
                end_date: end_date,
                object_type:this.state.object_type,
                object_code:this.state.object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
            }).then(response => {
            var valueKpi = '';
            if (response.data.data !== null) {
                valueKpi = response.data.data[0];
                //this.setState({kpiData: [...this.state.kpiData, response.data.data[0]]})
            }
            // else {
            //     this.setState({kpiData: [...this.state.kpiData, ""]})
            // }
            let ab = this.state.kpiData.slice(); //creates the clone of the state
            ab[index] = valueKpi;
            // console.log('kpi data');
            // console.log(ab);

            this.setState({kpiData: ab});
        });
    }

    getChart(chart_id, party_type, party_code, index, start_date, end_date) {
        // var mids = '';
        // var cids = '';
        // var sids = [25148];
        // var bids = '';
        // if(party_type=='Merchant') {
        //     mids = party_code;
        // } else if(party_type=='Chain') {
        //     cids = party_code;
        // } else if(party_type=='Store') {
        //     sids = party_code;
        // }
        // else if(party_type=='Acquirer Bank') {
        //     sids = party_code;
        // }

        axios.post(config.get('API_URL') + '/reportdashboard/charts/', {
                chart_id: chart_id,
                mids: this.state.merchantID,
                cids: this.state.chainID,
                sids: this.state.storeID,
                bids: this.state.acqBankIds,
                start_date: start_date,
                end_date: end_date,
                object_type:this.state.object_type,
                object_code:this.state.object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
            }).then(response => {
            var value = '';
            if (response.data.data !== null && response.data.data[0].dataProvider.length>0) {
                // console.log('chart details');
                // console.log(response.data.data);
                value = response.data.data[0];
            }
            // else {
            //    //this.setState({chart_data: [...this.state.chart_data, ""]})
            // }

            let a = this.state.chart_data.slice(); //creates the clone of the state
            a[index] = value;
            this.setState({chart_data: a});
        });
    }
    reset_all(e){
        this.setState({
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            merchantID:'',
            chainID:'',
            storeID:'',
            storeValue:[],
            merchantValue:[],
            chainValue:[],
            acqBankValue: [],
            acqBankIds:'',
            ciutidValue: [],
            ciutidIds: '',
            isChange: false,
        })

        setTimeout(function(){
            this.componentDidMount()
        }.bind(this), 200);
    }
    render() {

        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }

        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "15px",
                margin: "0px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "23px",
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px",
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "15px",
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px',
            }),
            menu: styles => ({ ...styles, zIndex: 999})
        };

        const store_lists = this.state.storeList.map((store_object, index) => {
            // console.log("store_object");
            // console.log(store_object);
            var chks_input = <input type='checkbox' checked={false}/>
            var activeCls_s = 'dd-list-item';
            var checked_items = false;
            if(this.state.storeID.includes(store_object.value) === true){
                chks_input = <input type='checkbox' checked={true}/>
                activeCls_s = "dd-list-item dd-list-active";
                checked_items = true;
            }
            return (
                <li key={index} className={activeCls_s} onClick={this.changeStore.bind(this, '', store_object,checked_items)}>
                    {chks_input}
                    &nbsp;&nbsp;{store_object.label}
                </li>
            )
        })
        let bindKPIData = this.state.kpiData.map((data, index) => {
            if(data==="")
            {
                return (
                    <div className="col-lg-3 remove-footer " key={index}>
                        <div className="card linear-background"></div>
                    </div>
                )
            }
            else {
                return (
                    <div className="col-lg-3 remove-footer " key={index}>
                        <KPI title={data.display_name} amount={ (data.display_unit  === null ? '' : data.display_unit)  +' '+ ( data.kpi_value  === null ? '0' : numDifferentiation(data.kpi_value)) } cssClass={data.css_class  === 'null' ? '' : data.css_class}/>
                    </div>
                )
            }
        });


        let charts_wizard = this.state.chart_data.map((chartData) => { //console.log(chartData)
            var charts = '';
            if (chartData.chart_type == 'Bar') {

                charts = <BarChart data={chartData.dataProvider} x_axis={chartData.x_axis[0]} y_axis={chartData.y_axis}
                                   chartHeight={this.state.chartHeight} name={chartData.display_name}/>

            } else if (chartData.chart_type == 'BarAndLine') {

                charts = <BarAndLineChart data={chartData.dataProvider} x_axis={chartData.x_axis[0]} y_axis={chartData.y_axis}
                                   chartHeight={this.state.chartHeight} name={chartData.display_name}/>

            } else if (chartData.chart_type == 'Pie of Pie') {


                charts = <PieofPieChart data={chartData.dataProvider} name={chartData.display_name}/>

            } else if (chartData.chart_type == 'Pie') {
                charts =
                    <PieChart data={chartData.dataProvider} x_axis={chartData.x_axis[0]} y_axis={chartData.y_axis[0]}
                              chartHeight={this.state.chartHeight}
                              name={chartData.display_name}
                              />
            } else if (chartData.chart_type == 'Line') {
                charts = <LineChart data={chartData.dataProvider} x_axis={numDifferentiation(chartData.x_axis[0])}
                                    y_axis={numDifferentiation(chartData.y_axis)}
                                    chartHeight={this.state.chartHeight}
                                    name={chartData.display_name}
                />
            } else if (chartData.chart_type == 'Column') {
                charts =
                    <ColumnChart data={chartData.dataProvider} x_axis={chartData.x_axis[0]} y_axis={chartData.y_axis}
                                 chartHeight={this.state.chartHeight} name={chartData.display_name}/>
            } else if (chartData.chart_type == 'StackColumn') {
                charts = <StackedColumnChart data={chartData.dataProvider} x_axis={numDifferentiation(chartData.x_axis[0])}
                                    y_axis={numDifferentiation(chartData.y_axis)}
                                    chartHeight={this.state.chartHeight}
                                    name={chartData.display_name}
                />
            }

//             if (chartData !== "")
//             {
//                 return (
//                     <div className="col-md-6">
//                         <div className="card">
//                             <div className="dash-header">
//                                 <p className="dash-title">{chartData.display_name}</p>
//                             </div>
//                             <div className="ChartContent">
//                                 {charts}
//                             </div>
//                         </div>
//                     </div>
//                 );
//         }

            if(chartData==="")
            {
                return (

                    <div className="col-md-6">
                        <div className="card linear-background-chart">
                            <div className="dash-header">

                                <p className="dash-title"></p>
                            </div>
                            <div className="ChartContent">

                            </div>
                        </div>
                    </div>
                )
            }
            else {
                return (
                    <div className="col-md-6">
                        <div className="card">
                            <div className="dash-header">

                                <p className="dash-title">{chartData.display_name}</p>
                            </div>
                            <div className="ChartContent">
                                {charts}
                            </div>
                        </div>
                    </div>
                )
            }
         });

        return (

            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div>
                                {/*<div className="col-md-12 no-padd">*/}
                                {/*    <div className="card title-card-bottom-space">*/}
                                {/*        <div className="header">*/}
                                {/*            <h4 className="title">Dashboard Details</h4>*/}
                                {/*            <p className="category"></p>*/}
                                {/*        </div>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                                {/*<hr/>*/}
                                <div className="content">

                                    {/*<div className="row">*/}
                                    {/*    <div className="">*/}
                                    {/*        <label className="leftLabel">Date Filter: </label>*/}
                                    {/*        <div className="rightBox">*/}
                                    {/*        <DatePicker*/}
                                    {/*            dateFormat="yyyy-MM-dd"*/}
                                    {/*            selected={Date.parse(this.state.startDate)}*/}
                                    {/*            onChange={this.handleFromChange}*/}
                                    {/*            maxDate={new Date()}*/}
                                    {/*        />*/}
                                    {/*         </div>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                    <div className="row">
                                        <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                            <div><label> Date Filter: </label></div>
                                                    {/*<DatePicker*/}
                                                    {/*    dateFormat="yyyy-MM-dd"*/}
                                                    {/*    selected={Date.parse(this.state.startDate)}*/}
                                                    {/*    onChange={this.handleFromChange}*/}
                                                    {/*    maxDate={new Date()}*/}
                                                    {/*/>*/}
                                            <DateRangePicker startDate={this.state.datefrom} endDate={this.state.dateTo}
                                                             onEvent={this.handleEvent.bind(this)} maxDate = {this.state.dateLimit}
                                                             minDate = {this.state.dateFromLimit}>
                                                <i className="fa fa-calendar" aria-hidden="true"></i>
                                                <input type="text" name="dateRange"
                                                       className="form-control dateRangeInput"
                                                       value={this.state.datefromShow + ' - ' + this.state.dateToShow}/>
                                            </DateRangePicker>
                                        </div>
                                        {this.state.merchant_list_box ===true?
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Merchants</label>
                                                <ReactMultiSelectCheckboxes name="merchants"
                                                    isMulti
                                                    isLoading={this.state.is_merchant_loading}
                                                    components={{ MenuList }}
                                                    value={this.state.merchantValue}
                                                    styles={customStyles} className="report-listbox"
                                                    isClearable={false}
                                                    onChange={this.changeMerchant.bind(this,'')}
                                                    options={this.state.merchantList}
                                                    placeholderButtonLabel="All"

                                                />

                                                <div className="clearfix"></div>
                                            </div> : null}
                                        {this.state.chain_list_box===true?
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Chain </label>
                                                <ReactMultiSelectCheckboxes name="chain"
                                                    isMulti
                                                    isLoading={this.state.is_chain_loading}
                                                    value={this.state.chainValue}
                                                    components={{ MenuList }}
                                                    styles={customStyles} className="report-listbox"
                                                    isClearable={false}
                                                    onChange={this.changeChain.bind(this,'')}
                                                    options={this.state.chainList}
                                                    placeholderButtonLabel="Select [Chain]"
                                                />
                                                <div className="clearfix"></div>
                                            </div> : null }
                                        {this.state.store_list_box===true?
                                            <div className="col-md-2 filter-bottom5 padd-5" >
                                                <label> Store: </label>
                                                <div className="dd-wrapper">
                                                    <div className="dd-header" onClick={() => this.storeToggleList()}>
                                                        {this.state.storeID==''?
                                                            <div className="dd-header-title">{this.state.storeHeaderTitle}</div>:
                                                            <div className="dd-header-title">{this.state.storeID.length} Selected</div>
                                                        }

                                                        <i className="fa fa-angle-down"></i>
                                                    </div>
                                                    {this.state.storeListOpen ===true?
                                                        <div
                                                            role="list"
                                                            onClick={(e) => e.stopPropagation()}
                                                        >
                                                            <input
                                                                className="dd-list-search-bar"
                                                                placeholder="Search"
                                                                onChange={(e) => this.storeFilterList(e)}
                                                            />
                                                            <i className="fa fa-search" style={{position:"absolute", left:"195px",color: "rgb(204, 204, 204)", marginTop:"5px", zIndex:2}}></i>

                                                            {/*<div className="dd-scroll-list">*/}
                                                            <ul className="dd-list">
                                                                {this.state.is_store_loading===true?
                                                                    <li>
                                                                        <BeatLoader
                                                                            css={override}
                                                                            sizeUnit={"px"}
                                                                            size={5}
                                                                            color={'#666666'}
                                                                            loading={this.state.is_store_loading}
                                                                        />
                                                                    </li>: null}
                                                                {store_lists}

                                                            </ul> </div>: null }
                                                    {/*</div>*/}
                                                </div>
                                                <div className="clearfix"></div>
                                            </div>: null }
                                        {this.state.acq_bank_list_box===true?
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Acquirer:</label>
                                                <ReactMultiSelectCheckboxes name="acqurier"
                                                    isMulti
                                                    value={this.state.acqBankValue}
                                                    styles={customStyles} className="report-listbox"
                                                    isClearable={false}
                                                    onChange={this.change_acq_banks.bind(this)}
                                                    options={this.state.acqBankList}
                                                    placeholderButtonLabel="Select [Acquirer]"
                                                />
                                                <div className="clearfix"></div>
                                            </div> :null }
                                        <div className="coll-md-4 pull-right dash-sync-con">
                                           <span
                                                className="dash-data-sync-sp"><span>Last updated: <b>{moment(this.state.last_updated).format('D MMM YYYY HH:mm:ss')}</b></span>
                                           </span>

                                        </div>


                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_dash_details.bind(this, this.state.dashId, this.state.object_type,this.state.object_code, this.state.yestSend, this.state.todSend)}>Apply</button>
                                            &nbsp; &nbsp;<button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>
                                    <div className="gap_ver"></div>

                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <hr/>
                                    <div className="row">
                                        {/*<div className="col-md-12">*/}
                                        {bindKPIData}
                                        {/*</div>*/}
                                    </div>
                                    <div className="row">
                                        {charts_wizard}
                                    </div>
                                    {/*<div className="col-md-6">*/}
                                    {/*    <div className="card">*/}
                                    {/*        <div className="header">*/}
                                    {/*            <h4 className="title">Stacked Column Chart</h4>*/}
                                    {/*            <p className="category">24 Hours performance</p>*/}
                                    {/*        </div>*/}
                                    {/*        <div className="ChartContent">*/}
                                    {/*            <StackedColumnChart data = {this.state.data}/>*/}
                                    {/*        </div>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                </div>

                                <div className="clearfix"></div>

                                <div className="footer">
                                    <div className="stats"><i></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               
            </div>

        );
    }
}
const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)(DashboardDetails );